/*eslint no-unused-vars: "off"*/
import _ from "lodash";
export const Getters = {
    isCompanyLoaded(state, getters) {
        return (getters['currentCompany/isLoadedCompanyInfo'])
    },
    isStatewide(state, getters) {
        return (getters['currentCompany/isStatewide'])
    },
    toastShowCount: state => {
      return state.toastShowCount
    },
    toastSettings: state => {
      return {
          toastContent: state.toastContent,
          toastOptions: state.toastOptions
      }
    },
    appLoadStatus: state => {
      return state.isLoadedApp
    },
    makes: (state,getters) => {
        if (getters.isStatewide){
            return state.statewideMakes
        }
        let makes = [];
        if (getters['currentCompany/isBikeRepairer']){
            makes = _.unionWith(state.bikeMakes, makes , _.isEqual);
        }
        if (getters['currentCompany/isMechanicRepairer']){
            makes = _.unionWith(state.makes, makes , _.isEqual);
        }
        if (getters['currentCompany/isTruckRepairer']){
            makes = _.unionWith(state.truckMakes, makes , _.isEqual);
        }
        if (getters['currentCompany/isCarRepairer']){
            makes = _.unionWith(state.makes, makes , _.isEqual);
        }
        return makes
    },
    truckMakes: state => {
        return state.truckMakes
    },
    isStartedReinstate: state => {
      return state.isStartedReinstate
    },
    quoteOpenDaysForRequest: state => {
      return state.quoteOpenDaysForRequest;
    },
    addressStates: state => {
        return state.addressStates;
    },
    addressCountries: state => {
        return state.addressCountries;
    },
    paymentTypes: state => {
        return state.paymentTypes;
    },
    vehicleTransmissions: state => {
        return state.vehicleTransmissions;
    },
    getActiveMainTemplateClass: (state, getters) => {
        let cssClass = 'theme-home';
        if (getters['currentUser/isUserTypeRepairer']) {
            cssClass = 'theme-repairer';
        } else if (getters['currentUser/isUserTypeSupplier']) {
            cssClass = 'theme-supplier';
        }
        if (getters['currentCompany/isBranding']) {
            cssClass += ' ' + getters['currentCompany/getBrandingClassName'];
        }
        return cssClass;
    },
    stockOptions(state) {
        return state.stockOptions
    },
    getSupplierBusinessTypes: state=>{
        return state.supplierBusinessTypes
    }
};
